import {numberFormatToCurrency} from '@yandex-delivery/core/formatters'

type FormatPriceOptions = {
  currencySign?: string
  country?: string
  currency?: string
}

export function formatPrice(price: string, {currency, country, currencySign}: FormatPriceOptions) {
  return numberFormatToCurrency(price, currency, country, {currencySign})
}
